import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
	deleteMedicalreport,
	getPatientmedicalreporstapi,
} from "../network/Network";
import { Link } from "react-router-dom";
import { edit } from "../Constant/Index";
import Norecord from "../Components/Norecord";

function Showusermedicalreport() {
	const token = useSelector((state) => state?.Auth?.token);
	const [getMedicalreport, setGetMedicalreport] = useState([]);

	// Delete Medical Report
	const Deletemedicalreport = (e, id) => {
		e.preventDefault();
		deleteMedicalreport(id, token)
			.then((res) => {
				// Filter out the deleted report by its ID
				setGetMedicalreport((prevReports) =>
					prevReports.filter((report) => report.id !== id),
				);
				// Show success message
				Swal.fire({
					position: "center",
					icon: "success",
					text: "Medical Report Has Been Deleted",
					showConfirmButton: false,
					timer: 1500,
				});
			})
			.catch((err) => {
				// Optionally, you can show an error message here
			});
	};
	// ======================

	// User Get Medical Reports
	useEffect(() => {
		getPatientmedicalreporstapi(token).then((res) => {
			setGetMedicalreport(res?.data);
		});
	}, []);
	// ====================
	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="row">
									<div className="col-md-6">
										<div className="main-heading d-flex align-items-center gap-3 mb-3">
											<div className="edit-btn back">
												<div className="nav-anchor">
													<i className="fa-solid fa-arrow-left"></i>
												</div>
											</div>
											<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
												My Medical Reports
											</h5>
										</div>
									</div>
									<div className="col-md-6">
										<div
											style={{
												float: "right",
											}}
											className="main-heading d-flex align-items-center gap-3 mb-3"
										>
											<div className="edit-btn back">
												<Link to="/medical-report">
													<div className="nav-anchor">
														{/* <i className="fa-solid fa-arrow-left"></i> */}
														<img src={edit} alt="Edit" className="img-fluid" />
													</div>
												</Link>
											</div>
											<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
												Upload Medical Reports
											</h5>
										</div>
									</div>
								</div>

								<form>
									<div className="row input-file-wrapper">
										<div className="form-group col-lg-12 ">
											{getMedicalreport?.length > 0 ? (
												<>
													<div className="position-relative my_dv_report">
														<ul className="mt-3">
															{getMedicalreport?.map((item, rindex) => (
																<li
																	className="form-group d-flex-wrapper-upload col-lg-12 m-2"
																	key={rindex}
																>
																	<div className="pdf-icon">
																		<i className="fa-solid fa-file-pdf"></i>
																	</div>
																	{item.file_name}
																	<div className="close_tag">
																		<i
																			style={{
																				cursor: "pointer",
																			}}
																			onClick={(e) =>
																				Deletemedicalreport(e, item?.id)
																			}
																			className="fa-solid fa-xmark"
																		></i>
																	</div>
																</li>
															))}
														</ul>
													</div>
												</>
											) : (
												<Norecord />
											)}
										</div>
									</div>

									<div className="row"></div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
}

export default Showusermedicalreport;
